"use client";
import type { ReactElement } from "react";
import { getFontFamily } from "@/theme/typography";
import { GanttTaskStatus } from "./gantt-types";
export interface GanttTooltipStatusBadgeProps {
    status: GanttTaskStatus;
    statusLabel: string;
    statusColor: string;
}
export function GanttTooltipStatusBadge({ status, statusLabel, statusColor, }: GanttTooltipStatusBadgeProps): ReactElement | null {
    if (status === GanttTaskStatus.None) {
        return null;
    }
    return (
      <div style={{
            marginTop: 8,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "2px 8px",
            borderRadius: 999,
            fontFamily: getFontFamily(),
            fontSize: 10,
            fontWeight: 700,
            color: statusColor,
            border: `1px solid ${statusColor}55`,
            backgroundColor: `${statusColor}1A`,
        }}>
        {statusLabel}
      </div>
    );
}
